module.exports = __webpack_public_path__ + "img/2.7fefb1d5.jpeg";